import React from "react";
import { Star } from "lucide-react";

const StarRating = ({ value = 0, onChange, size = "md", readOnly = false, testid }) => {
  const sizes = { sm: "w-4 h-4", md: "w-6 h-6", lg: "w-8 h-8" };
  const cls = sizes[size] || sizes.md;
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          onClick={() => !readOnly && onChange?.(n)}
          className={`transition-transform ${readOnly ? "" : "hover:scale-110"} focus:outline-none`}
          aria-label={`${n} star${n > 1 ? "s" : ""}`}
          data-testid={testid ? `${testid}-star-${n}` : undefined}
        >
          <Star
            className={`${cls} ${n <= value ? "fill-amber-400 text-amber-400" : "text-navy/20"}`}
          />
        </button>
      ))}
    </div>
  );
};

export default StarRating;
